import { useContext } from "react";
import { Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { WebrtcContext } from "../../modules/Webrtc";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import { ChevronRight } from '@mui/icons-material';
import VideoItem from "../VideoContainer/VideoItem";
import VideoContainer from "../VideoContainer/VideoContainer";
import Carousel from 'better-react-carousel';
const useStyles = makeStyles(() => ({
	streamItem: {
		width: "100%",
		display: "inline-block",
		textTransform: "uppercase",
		fontSize: "14px",
		backgroundColor: "black",
		borderColor: "black",
		border: "4px solid transparent",
		cursor: "pointer",
	},
	activeItem: {
		border: "4px solid #00ABB3",
	},
}));

const OneViewComponent = ({}: any) => {
	const classes = useStyles();

	const { streamActiveListe, streamActive, handleAddActiveStream } =
		useContext(WebrtcContext);

	return streamActiveListe?.length > 0 ? (
		<div className="stream-container">

			<div className="stream-header">
				<div className="streamName">
					{streamActive?.remotePeer?.email} <ChevronRight />
					{streamActive?.streamName}
				</div>

				<div className="streamList">
					<Button
						variant="text"
						size="medium"
						startIcon={<ViewModuleIcon />}
						onClick={() => {
							handleAddActiveStream({});
						}}
					>
						List
					</Button>
				</div>
			</div>

			<div className="stream-body">
				<VideoContainer />
			</div>

			<div className="stream-footer">
				<Carousel cols={4} rows={1} gap={10} loop>
					{[...streamActiveListe].map((i, key) => (
						<Carousel.Item>
							<div
								key={key + "____"}
								className={`${classes.streamItem} ${i === streamActive ? classes.activeItem : ""}`}
									onClick={() => {
									handleAddActiveStream(i);
								}}
							>
								{key + 1} - {i.streamName.length > 6 ? i.streamName.substring(0, 6) + "..." : i.streamName}
								<VideoItem small={true} curr={i} />
							</div>
						</Carousel.Item>
					))}
				</Carousel>
			</div>
		</div>
		) : (
		<div />
	);
};

export default OneViewComponent;
